import { apiRequest } from './apiClient';

export async function getStudentClassContents(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classSubjectId) {
    params.set('classSubjectId', filters.classSubjectId);
  }

  if (filters.status) {
    params.set('status', filters.status);
  }

  const query = params.toString();
  const response = await apiRequest(`/student/class-contents${query ? `?${query}` : ''}`);

  return response.data || [];
}

export async function getStudentClassContentById(contentId) {
  const response = await apiRequest(`/student/class-contents/${contentId}`);

  return response.data || null;
}

export async function getPublishedContentsCount() {
  const contents = await getStudentClassContents({ status: 'published' });

  return Array.isArray(contents) ? contents.length : 0;
}
